export default {
  woundAge: {
    numOfDays: '',
    ageParameterCode: '',
  },
};
